<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MdopAddMain from '@/views/MouldManagement/MdopManage/TabChild/MdopAddMain';
export default {
  name: 'MdopAdd',
  components: {
    childTab1: MdopAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
